import { render, staticRenderFns } from "./StandardInput.vue?vue&type=template&id=1203a937&scoped=true"
import script from "./StandardInput.vue?vue&type=script&lang=js"
export * from "./StandardInput.vue?vue&type=script&lang=js"
import style0 from "./StandardInput.vue?vue&type=style&index=0&id=1203a937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1203a937",
  null
  
)

export default component.exports